import React, { useState } from "react";
import "./ProtectedResource.css";

export default function ProtectedResource() {
  const [password, setPassword] = useState("");
  const [authorized, setAuthorized] = useState(false);

  const correctPassword = "WorkshopMar2025";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setAuthorized(true);
    } else {
      alert("Incorrect password, please try again.");
      setPassword("");
    }
  };

  return (
    <div className="resource-container">
      {!authorized ? (
        <form onSubmit={handleSubmit}>
          <h2>Exclusive Content</h2>
          <p className="resource-description">
            Enter your workshop password to unlock premium resources and
            materials.
          </p>
          <div className="lock-icon">🔒</div>
          <input
            type="password"
            placeholder="Enter Workshop Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-field"
            required
          />
          <button type="submit" className="primary-btn">
            Submit
          </button>
        </form>
      ) : (
        <div>
          <h2>Download Your Exclusive Resource 🎉</h2>
          <a
            href="/docs/Precision%20Prompting%20by%20Agent%20Samur.AI-protected.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="primary-btn"
          >
            Download PDF
          </a>
        </div>
      )}
    </div>
  );
}
